






































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ICheckoutCartOfferTestimonial } from '@/interfaces/Checkout';

@Component
export default class Testimonial extends Vue {
  @Prop()
  private readonly testimonial!: ICheckoutCartOfferTestimonial['testimonial_data'];

  @Prop({ default: '' })
  private readonly customClass!: string;

  private get avatarUrl () {
    return this.testimonial && this.testimonial.checkout_img_url;
  }

  private get stars () {
    if (!this.testimonial.score) {
      return {};
    }

    const stars = this.testimonial.score / 2;
    const starsRest = stars % 1;
    const starsFullFilled = stars - starsRest;
    const starsHalfFilled = starsRest > 0 ? 1 : 0;
    const remainingStars = 5 - (starsHalfFilled + starsFullFilled);

    return {
      halfFilled: starsHalfFilled,
      fullFilled: starsFullFilled,
      unfilled: remainingStars
    };
  }
}
